import { render, staticRenderFns } from "./categoriesPDI.vue?vue&type=template&id=caebcd9a"
import script from "./categoriesPDI.vue?vue&type=script&lang=js"
export * from "./categoriesPDI.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports